module.exports = __webpack_public_path__ + "img/qrwechat.c366bf04.jpg";